// Utility functions for membership/login flows

/**
 * Takes an array of field options and returns a React select option component
 */
export const arrayToSelectOptions = (array: string[] = []) => {
  if (!Array.isArray(array)) return [{ value: "", label: "" }];

  return array.map((item) => ({ value: item, label: item }));
};

/**
 * Converts an object to a URL query string
 */
export function objectToQueryString(object: {}): string {
  return Object.keys(object)
    .map((key) => {
      return (
        encodeURIComponent(key) +
        "=" +
        encodeURIComponent(object[key] as string)
      );
    })
    .join("&");
}
